module.exports = __webpack_public_path__ + "media/img/icons/logout-2a195bd83eca0a04b7862f5a0045c60a.png";